import { render, staticRenderFns } from "./educationAdminEdit.vue?vue&type=template&id=0a9b182c"
import script from "./educationAdminEdit.vue?vue&type=script&lang=js"
export * from "./educationAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9b182c')) {
      api.createRecord('0a9b182c', component.options)
    } else {
      api.reload('0a9b182c', component.options)
    }
    module.hot.accept("./educationAdminEdit.vue?vue&type=template&id=0a9b182c", function () {
      api.rerender('0a9b182c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/educationAdminEdit.vue"
export default component.exports